<div class="header-parent-title">
  <div class="header-child-title">Locations</div>
  <div class="header-child-title">.</div>
</div>
<div class="abp-post-locations-table">
  <p-table
    #locationList
    [value]="tableData"
    [loading]="loading"
    [lazy]="true"
    [lazyLoadOnInit]="true"
    [first]="offset"
    [totalRecords]="paginatorLength"
    responsiveLayout="scroll"
    [globalFilterFields]="['storeCode', 'businessName', 'status', 'location_id']"
    (onLazyLoad)="lazyLoadLocations($event)"
  >
    <ng-template pTemplate="caption">
      <div class="flex-search-bar">
        <div class="search-bar-buttons">
          <div class="acct-search">
            <span class="p-input-icon-right">
              <i class="pi pi-search"></i>
              <span class="p-inputgroup">
                <input
                  class="input"
                  pInputText
                  type="text"
                  placeholder="Search"
                  (input)="locationList.filterGlobal($event.target.value, 'contains')"
                  [(ngModel)]="keyword"
                />
              </span>
            </span>
          </div>
          <button
            *ngIf="addLocation"
            pButton
            label="ADD LOCATION"
            class="p-button-primary button-div-flex"
            iconPos="left"
            icon="pi pi-plus-circle"
            (click)="openAddLocation()"
          ></button>
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th>Store Code</th>
        <th>Business Name</th>
        <th>Status</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-location>
      <tr>
        <td>{{ location.storeCode || location.storecode || '-' }}</td>
        <td>{{ location.businessName || location.business_name || '-' }}</td>
        <td>{{ location.status || '-' }}</td>
      </tr>
    </ng-template>
  </p-table>
  <p-paginator
    styleClass="multiselect-paginator"
    [rows]="paginatorRows"
    [totalRecords]="paginatorLength"
    [showCurrentPageReport]="true"
    [currentPageReportTemplate]="'Showing {first} to {last} of {totalRecords} locations.'"
    (onPageChange)="onPageChange($event)"
  >
  </p-paginator>
</div>
